import { useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import InternalHeader from "../components/InternalHeader";
import BottomNav from "../components/BottomNav";
import { useAppState } from "../context/AppState";
import { authenticatedApi } from "../lib/api";

function Stars({ label, value, onChange }) {
  return (
    <fieldset className="rating-stars">
      <legend>{label}</legend>
      <div>
        {[1, 2, 3, 4, 5].map((star) => (
          <button
            aria-label={`${star} estrellas`}
            className={star <= value ? "is-active" : ""}
            key={star}
            onClick={() => onChange(star)}
            type="button"
          >
            ★
          </button>
        ))}
      </div>
    </fieldset>
  );
}

export default function RateOrderPage() {
  const { orderId } = useParams();
  const navigate = useNavigate();
  const { user } = useAppState();
  const [order, setOrder] = useState(null);
  const [storeRating, setStoreRating] = useState(5);
  const [deliveryRating, setDeliveryRating] = useState(5);
  const [storeReview, setStoreReview] = useState("");
  const [deliveryReview, setDeliveryReview] = useState("");
  const [loading, setLoading] = useState(Boolean(user));
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState("");

  useEffect(() => {
    if (!user?.auth_token) return;
    authenticatedApi("/get-ratable-order", user.auth_token, {
      method: "POST",
      body: JSON.stringify({ order_id: orderId }),
    })
      .then(setOrder)
      .catch((requestError) => setError(requestError.message))
      .finally(() => setLoading(false));
  }, [orderId, user?.auth_token]);

  const submit = async (event) => {
    event.preventDefault();
    setSaving(true);
    setError("");
    try {
      const result = await authenticatedApi("/rate-order", user.auth_token, {
        method: "POST",
        body: JSON.stringify({
          order_id: orderId,
          rating_store: storeRating,
          rating_delivery: deliveryRating,
          review_store: storeReview.trim(),
          review_delivery: deliveryReview.trim(),
        }),
      });
      if (!result.success) throw new Error(result.message || "No se pudo guardar la calificación.");
      navigate(`/orders/${encodeURIComponent(order.unique_order_id)}`, { replace: true });
    } catch (requestError) {
      setError(requestError.message);
    } finally {
      setSaving(false);
    }
  };

  return (
    <main className="food-app">
      <InternalHeader title="Calificar pedido" backTo="/orders" />
      <div className="rating-page">
        {!user && (
          <section className="empty-cart">
            <h2>Inicia sesión para calificar</h2>
            <Link to={`/account?next=/rate-order/${orderId}`}>Ir a mi cuenta</Link>
          </section>
        )}
        {loading && <div className="food-message"><b>Cargando pedido…</b></div>}
        {error && <div className="food-message food-message--error"><b>{error}</b></div>}
        {order?.rating && <div className="food-message"><b>Este pedido ya fue calificado.</b></div>}
        {order && !order.rating && (
          <form className="rating-form" onSubmit={submit}>
            <header>
              <span>🍽️</span>
              <div>
                <h2>{order.restaurant?.name || "Negocio"}</h2>
                <small>Pedido {order.unique_order_id}</small>
              </div>
            </header>
            <Stars label="¿Cómo estuvo el negocio y tu pedido?" value={storeRating} onChange={setStoreRating} />
            <label>
              Comentario sobre el negocio
              <textarea value={storeReview} onChange={(event) => setStoreReview(event.target.value)} maxLength={500} />
            </label>
            <Stars label="¿Cómo fue la entrega?" value={deliveryRating} onChange={setDeliveryRating} />
            <label>
              Comentario sobre el motorizado
              <textarea value={deliveryReview} onChange={(event) => setDeliveryReview(event.target.value)} maxLength={500} />
            </label>
            <button className="auth-submit" disabled={saving} type="submit">
              {saving ? "Guardando…" : "Enviar calificación"}
            </button>
          </form>
        )}
      </div>
      <BottomNav />
    </main>
  );
}
